import React from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import "yet-another-react-lightbox/styles.css";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import PredefinedDateRanges from "../../../core/common/datePicker";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import CommonSelect from "../../../core/common/commonSelect";

const Gallery = () => {
  const carouselData = [
    {
      id: 1,
      relatdImage: "Blood Test",
      images: [
        "https://team1consulting.com/weconnect//assets/img/moments/blood-test/blood-test-1.jpg",
        "https://team1consulting.com/weconnect//assets/img/moments/blood-test/blood-test-4.jpg",
        "https://team1consulting.com/weconnect//assets/img/moments/blood-test/blood-test-5.jpg",
      ],
    },
    {
      id: 2,
      relatdImage: "Cricket Match",
      images: [
        "https://team1consulting.com/weconnect//assets/img/moments/cricket-match/cricket-match-1.jpg",
        "https://team1consulting.com/weconnect//assets/img/moments/cricket-match/cricket-match-3.jpg",
        "https://team1consulting.com/weconnect//assets/img/moments/cricket-match/cricket-match-11.jpg",
      ],
    },
    {
      id: 3,
      relatdImage: "Donation",
      images: [
        "https://team1consulting.com/weconnect//assets/img/moments/donation/donation-1.jpg",
        "https://team1consulting.com/weconnect//assets/img/moments/donation/donation-2.jpg",
        "https://team1consulting.com/weconnect//assets/img/moments/donation/donation-3.jpg",
      ],
    },
    {
      id: 4,
      relatdImage: "Christmas Day 2023",
      images: [
        "https://team1consulting.com/weconnect//assets/img/moments/republic-day-2024/republic-day-1.jpg",
        "https://team1consulting.com/weconnect//assets/img/moments/republic-day-2024/republic-day-3.jpg",
        "https://team1consulting.com/weconnect//assets/img/moments/republic-day-2024/republic-day-2.jpg",
      ],
    },
    {
      id: 5,
      relatdImage: "Diwali 2023",
      images: [
        "https://team1consulting.com/weconnect//assets/img/moments/christmas-2023/christmas-2023-1.jpg",
        "https://team1consulting.com/weconnect//assets/img/moments/christmas-2023/christmas-2023-4.jpg",
        "https://team1consulting.com/weconnect//assets/img/moments/christmas-2023/christmas-2023-3.jpg",
      ],
    },
    {
      id: 6,
      relatdImage: "Republic Day 2024",
      images: [
        "https://team1consulting.com/weconnect//assets/img/moments/republic-day-2023/iii.jpg",
        "https://team1consulting.com/weconnect//assets/img/moments/republic-day-2023/ii.jpg",
        "https://team1consulting.com/weconnect//assets/img/moments/republic-day-2023/i.jpg",
      ],
    },
  ];
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Gallery</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Content</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Gallery
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="me-2 mb-2">
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-file-export me-1" />
                    Export
                  </Link>
                </div>
              </div>
              <div className="mb-2">
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-inert={true}
                  data-bs-target="#add_blog"
                  className="btn btn-primary d-flex align-items-center"
                >
                  <i className="ti ti-circle-plus me-2" />
                  Add Gallery
                </Link>
              </div>
              <div className="ms-2 head-icons">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          <div className="card">
            <div className="card-body p-3">
              <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                <h5>Gallery </h5>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            {carouselData.map((item, index) => (
              <div className="col-xxl-4 col-md-6">
                <div key={index} className="card">
                  <div className="card-body">
                    <div className="img-sec w-100 position-relative mb-3">
                      {/* <Link to={all_routes.blogCategories}> */}
                      <Link to="#">
                        <img
                          src={item.images[0]}
                          className="img-fluid rounded w-100"
                          alt="img"
                          style={{ height: "250px" }}
                        />
                      </Link>
                      <div className="">
                        <span className="trend-tag badge bg-info-transparent fs-10 fw-medium">
                          {item.relatdImage}
                        </span>
                        {/* <span className="badge badge-success dot-icon">
                                                    <i className="ti ti-point-filled" /> Active
                                                </span> */}
                      </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <div className="d-flex align-items-center">
                        <span className="me-2 d-flex align-items-center">
                          <i className="ti ti-calendar me-1" /> 05/10/2024
                        </span>
                        <Link
                          to="#"
                          className="border-start link-default fs-14 fw-normal ps-2 me-2 text-truncate"
                        >
                          {item.relatdImage}
                        </Link>
                      </div>
                      {/* <div className="d-flex align-items-center">
                                                <Link
                                                    to="#"
                                                    className="link-default me-2"
                                                    data-bs-toggle="modal" data-inert={true}
                                                    data-bs-target="#edit_blog"
                                                >
                                                    <i className="ti ti-edit" />
                                                </Link>
                                                <Link
                                                    to="#"
                                                    className="link-default"
                                                    data-bs-toggle="modal" data-inert={true}
                                                    data-bs-target="#delete_modal"
                                                >
                                                    <i className="ti ti-trash" />
                                                </Link>
                                            </div> */}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mb-4">
            <Link to="#" className="btn btn-white border">
              <i className="ti ti-loader-3 text-primary me-2" />
              Load More
            </Link>
          </div>
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">© 2026 Aupertz. All rights reserved.</p>
          <p>
            Designed &amp; Developed By{" "}
            <Link to="#" className="text-primary">
              Bizclockarts
            </Link>
          </p>
        </div>
      </div>
      <div className="modal fade" id="add_blog">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Add Gallery</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form action="blogs.html">
              <div className="modal-body pb-0">
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Gallery Title <span className="text-danger"> *</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Write Gallery Title"
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="d-flex align-items-center flex-wrap row-gap-3 bg-light w-100 rounded p-3 mb-4">
                      <div className="d-flex align-items-center justify-content-center avatar avatar-xxl rounded-circle border border-dashed me-2 flex-shrink-0 text-dark frames">
                        <ImageWithBasePath
                          src="assets/img/profiles/avatar-30.jpg"
                          alt="img"
                          className="rounded-circle"
                        />
                      </div>
                      <div className="profile-upload">
                        <div className="mb-2">
                          <h6 className="mb-1">Featured Images</h6>
                          <p className="fs-12">Image should be below 4 mb</p>
                        </div>
                        <div className="profile-uploader d-flex align-items-center">
                          <div className="drag-upload-btn btn btn-sm btn-primary me-2">
                            Upload
                            <input
                              type="file"
                              className="form-control image-sign"
                              multiple
                            />
                          </div>
                          <Link to="#" className="btn btn-light btn-sm">
                            Cancel
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  data-bs-dismiss="modal"
                  className="btn btn-primary"
                >
                  Add Gallery
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Gallery;
